import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.public.apply');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;
declare const WizRoute: any;

@Component({
    selector: 'wiz-page-public-apply',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.public.apply/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PagePublicApplyComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = true;
    public errorMsg: string = '';
    public submitted: boolean = false;
    public submitting: boolean = false;
    public submittedId: string = '';

    public program_id: string = '';
    public program: any = null;

    public form: any = {
        company_name: '',
        registed_number: '',
        ceo_name: '',
        ceo_email: '',
        ceo_phone: '',
        business_area: '',
        employee_count: '',
        revenue: '',
        requested_amount: '',
        summary: '',
    };

    public async ngOnInit() {
        await this.service.init();
        this.program_id = (WizRoute.segment && WizRoute.segment.program_id) || '';
        if (!this.program_id) {
            this.errorMsg = '지원사업 ID가 누락되었습니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        const r = await wiz.call('get_program', { program_id: this.program_id });
        if (r.code != 200) {
            this.errorMsg = r.data?.message || '지원사업을 찾을 수 없습니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        this.program = r.data.data;
        this.loading = false;
        await this.service.render();
    }

    public async submit() {
        if (!this.form.company_name?.trim()) { alert('기업명을 입력해주세요.'); return; }
        if (!this.form.ceo_email?.trim()) { alert('대표 이메일을 입력해주세요.'); return; }
        if (!this.form.ceo_name?.trim()) { alert('대표자명을 입력해주세요.'); return; }
        this.submitting = true;
        await this.service.render();
        const r = await wiz.call('submit', {
            program_id: this.program_id,
            data: JSON.stringify(this.form),
        });
        this.submitting = false;
        if (r.code != 200) {
            alert(r.data?.message || '제출 중 오류가 발생했습니다.');
            await this.service.render();
            return;
        }
        this.submittedId = r.data.id;
        this.submitted = true;
        await this.service.render();
    }
}

export default PagePublicApplyComponent;